import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ThemeMode } from '@/types/common.types';
import { STORAGE_KEYS } from '@/constants/storage-keys.constants';

export interface ThemeState {
  mode: ThemeMode;
}

function getPreferredMode(): ThemeMode {
  const stored = window.localStorage.getItem(STORAGE_KEYS.THEME_MODE);

  if (stored === 'light' || stored === 'dark') {
    return stored;
  }

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

const initialState: ThemeState = {
  mode: getPreferredMode(),
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setMode(state, action: PayloadAction<ThemeMode>) {
      state.mode = action.payload;
      window.localStorage.setItem(STORAGE_KEYS.THEME_MODE, action.payload);
    },
    toggleMode(state) {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      window.localStorage.setItem(STORAGE_KEYS.THEME_MODE, state.mode);
    },
  },
});

export const { setMode, toggleMode } = themeSlice.actions;
export const themeReducer = themeSlice.reducer;
